import AOS from 'aos';
import Cookie from 'tiny-cookie';
import Flickity from 'flickity';
import jQueryBridget from 'jquery-bridget';
import selectricFactory from 'selectric/public/jquery.selectric.js';

window.AOS = AOS;
window.Cookie = Cookie;

// flickity.pkgd.js's browserify-style internal require()s don't resolve
// under Rollup, so we import the ESM entry directly and wire up the jQuery
// plugin bridge ourselves (the same thing the "pkgd" build did for us).
jQueryBridget('flickity', Flickity, window.jQuery);

// selectric's UMD wrapper takes its CommonJS branch under Rollup (since
// `module` exists there), which just *exports* the plugin factory instead
// of invoking it like the "browser globals" branch would - so importing it
// as a side effect never actually sets $.fn.selectric. Call it ourselves.
selectricFactory(window, window.jQuery);

// Fancybox's default smallBtn: "auto" adds its own close button directly on
// inline/html content slides, in addition to the main toolbar's close
// button - showing two "x" controls on every modal. We don't use smallBtn
// for anything else, so disable it globally rather than per-instance.
window.jQuery.fancybox.defaults.smallBtn = false;
